/** @module blank LINE LPのスクリプト */
import $ from 'jquery';
import 'jquery-inview';

$(function() {
  // スクロール時に横からimageがfade-inする処理
  $('.line_lp_list-mv05, .line_lp_list-mv06').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
    if (isInView){
      $(this).stop().addClass('line_lp_mv06');
    }
    else {
      $(this).stop().removeClass('line_lp_mv06');
    }
  });
});
